module.exports = __webpack_public_path__ + "img/222.72604a02.png";